/* ── SHARED PRICING SOURCE OF TRUTH ──
   Single definition consumed by Main, Products, Faq, and Press so the
   tiers never drift out of sync across pages again.
   No free tier — see /trust: every account is confirmed via email
   verification and rate-limited signup, not an open anonymous tier. */
export const PRICING_TIERS = [
  {
    id: 'developer',
    name: 'Developer',
    priceLabel: '$39',
    per: '/mo',
    caption: 'Up to 5 servers',
    features: ['Up to 5 servers', '3 users', '30-day log retention', 'Email support'],
  },
  {
    id: 'business',
    name: 'Business',
    priceLabel: '$149',
    per: '/mo',
    caption: 'Up to 25 servers',
    features: ['Up to 25 servers', '20 users', '90-day log retention', 'Operator-configured response actions', 'Compliance reporting'],
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    priceLabel: 'Custom',
    per: '',
    caption: 'Contact sales',
    features: ['Unlimited servers', 'SSO and SCIM provisioning', 'Custom roles, two-person approval', 'Audit log export', 'Dedicated support, custom SLAs'],
  },
];
